// extracted by mini-css-extract-plugin
export default {"paragraphWrapper":"style_paragraphWrapper__-y6Q4","paragraph":"style_paragraph__Pp3Pt","word":"style_word__Ictv-"};